import { request } from "services/api/util";

class CustomerService {
  async forgotPassword(data) {
    const config = {
      method: "post",
      url: `forgetPasswordForCustomer`,
      data: data,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }

  async getListCustomer(param) {
    const config = {
      method: "get",
      url: `admin/customerProfile`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailCustomer(id) {
    const config = {
      method: "get",
      url: `admin/customerProfile/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateCustomerProfile(id, body) {
    const config = {
      method: "patch",
      url: `admin/customerProfile/${id}`,
      data: body,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
}

export default new CustomerService();
